// Uncomment the needed environment

// module.exports = "http://localhost:1337";
// module.exports = "https://sandbox.tomorrowltd.com";
module.exports = "https://sandbox1.tomorrowltd.com";
// module.exports = "https://portal.tomorrowltd.com";
